// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout_main__2pYrJ","content":"Layout_content__MVJbw","asideLeft":"Layout_asideLeft__CV1ZV","asideRight":"Layout_asideRight__Rscu9","sticky":"Layout_sticky__17ZxP"};